import React from "react"
import Layout from "../components/Layout"
import Payment from "../components/Payment"

export default () => {
  return (
    <Layout toHome={true}>
      <Payment />
    </Layout>
  )
}
